import {Card} from '@mui/material';
import {styled} from '@mui/material/styles';

export const AppCard = styled(Card)(props => ({
    marginBottom: props.theme.spacing(2),
    '&:last-child': {
        marginBottom: '0px',
    }
}));
